import * as React from "react";
import { SVGProps } from "../types";

const AlfaBankIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <circle cx="16" cy="16" r="14" fill="#EE2A23"></circle>
    <path
      fill="#fff"
      d="M9 22.78c0-.1.096-.182.216-.182h13.565c.123 0 .219.082.219.183v2.037c0 .1-.096.182-.219.182H9.216c-.12 0-.216-.081-.216-.182z"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16.002 7c1.484 0 1.95.879 2.341 1.756l4.137 9.351c.031.073.01.193-.126.236s-2.14.686-2.251.72c-.111.036-.236-.015-.276-.107-.041-.09-.873-1.99-.966-2.203h-5.717c-.09.212-.931 2.117-.969 2.203-.038.087-.158.147-.276.107l-2.25-.72c-.115-.037-.168-.145-.128-.236.142-.326 3.94-8.904 4.134-9.351.377-.864.86-1.756 2.347-1.756m-1.946 7.635 1.957-4.789 1.94 4.79z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export { AlfaBankIcon };
